// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*SCSS mixins for devices*/
[data-theme=light] {
  --hover-bg: #c9c8c8;
}

[data-theme=dark] {
  --hover-bg: #3a3a3a;
}

.loginContainer {
  min-width: 80px;
  justify-content: center;
  display: flex;
  align-items: center;
}
@media (max-width: 767px) {
  .loginContainer {
    justify-content: center;
    display: flex;
  }
}
.loginContainer .profileIcon {
  background-color: var(--button-bg);
  color: var(--button-fg);
  border-radius: 50px;
  padding: 0.5rem 0.5rem;
  border: none;
  text-decoration: none;
}
.loginContainer .profileIconWithImage {
  display: flex;
  align-items: center;
  justify-content: center;
}
.loginContainer .profileIconWithImage img {
  border-radius: 50px;
  width: 35px;
  height: 35px;
}
.loginContainer .dropdown {
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: var(--color-bg);
  color: var(--color-fg);
  position: absolute;
  right: 3rem;
  top: 3.5rem;
  border-radius: 10px;
  min-width: 15rem;
  width: auto;
  -webkit-box-shadow: 0px 2px 11px 0px rgba(0, 0, 0, 0.46);
  -moz-box-shadow: 0px 2px 11px 0px rgba(0, 0, 0, 0.46);
  box-shadow: 0px 2px 11px 0px rgba(0, 0, 0, 0.46);
}
@media (max-width: 767px) {
  .loginContainer .dropdown {
    right: 1rem;
    top: 4.5rem;
  }
}
.loginContainer .dropdown div {
  width: 100%;
}
.loginContainer .dropdown .profile__details {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  line-height: 2.5rem;
  gap: 0.5rem;
  flex-direction: column;
  border-bottom: 1px solid var(--border-color);
}
.loginContainer .dropdown .profile__details .profileIconWithImage img {
  width: 60px;
  height: 60px;
}
.loginContainer .dropdown .profile__details div {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loginContainer .dropdown .profile__details a {
  width: 50px;
  height: 50px;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loginContainer .dropdown .logout__container a {
  padding: 0.5rem 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
.loginContainer .dropdown .logout__container a:hover {
  background-color: var(--hover-bg);
  border-radius: 0 0 10px 10px;
}
.loginContainer .dropdown a {
  text-decoration: none;
  display: block;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/_styles.scss","webpack://./src/components/LoginButton.scss"],"names":[],"mappings":"AAAA,0BAAA;ACEA;EACI,mBAAA;AAAJ;;AAGA;EACI,mBAAA;AAAJ;;AAGA;EACI,eAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;AAAJ;ADTE;ECKF;IAOQ,uBAAA;IACA,aAAA;EACN;AACF;AACI;EACI,kCAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;AACR;AAEI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AAAR;AAGI;EACI,mBAAA;EACA,WAAA;EACA,YAAA;AADR;AAII;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,iCAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,wDAAA;EACA,qDAAA;EACA,gDAAA;AAFR;ADjDE;ECqCE;IAkBQ,WAAA;IACA,WAAA;EAFV;AACF;AAIQ;EACI,WAAA;AAFZ;AAKQ;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,4CAAA;AAHZ;AAKY;EACI,WAAA;EACA,YAAA;AAHhB;AAMY;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAJhB;AAMY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAJhB;AASY;EACI,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAPhB;AAQgB;EACI,iCAAA;EACA,4BAAA;AANpB;AAWQ;EACI,qBAAA;EACA,cAAA;EACA,eAAA;AATZ","sourcesContent":["/*SCSS mixins for devices*/\n\n$mobile-max-width: 767px;\n\n@mixin mobile {\n  @media (max-width: $mobile-max-width) {\n    @content;\n  }\n}\n\n// Tablet screens (768px to 1024px)\n@mixin tablet {\n  @media (min-width: 768px) and (max-width: 1024px) {\n    @content;\n  }\n}\n\n// Desktop screens (1025px to 1439px)\n@mixin desktop {\n  @media (min-width: 1025px) and (max-width: 1439px) {\n    @content;\n  }\n}\n\n// Big monitor screens (1440px and up)\n@mixin big-monitor {\n  @media (min-width: 1440px) {\n    @content;\n  }\n}","@use '../styles';\n\n[data-theme=\"light\"] {\n    --hover-bg: #c9c8c8;\n}  \n\n[data-theme=\"dark\"] {\n    --hover-bg: #3a3a3a;\n}\n\n.loginContainer {\n    min-width: 80px;\n    justify-content: center;\n    display: flex;\n    align-items: center;\n    \n    @include styles.mobile {\n        justify-content: center;\n        display: flex;\n    }\n\n    .profileIcon {\n        background-color: var(--button-bg);\n        color: var(--button-fg);\n        border-radius: 50px;\n        padding: .5rem .5rem;\n        border: none;\n        text-decoration: none;\n    }\n\n    .profileIconWithImage {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    .profileIconWithImage img {\n        border-radius: 50px;\n        width: 35px;\n        height: 35px;\n    }\n\n    .dropdown {\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n        background-color: var(--color-bg);\n        color: var(--color-fg);\n        position: absolute;\n        right: 3rem;\n        top: 3.5rem;\n        border-radius: 10px;\n        min-width: 15rem;\n        width: auto;\n        -webkit-box-shadow: 0px 2px 11px 0px rgba(0,0,0,0.46);\n        -moz-box-shadow: 0px 2px 11px 0px rgba(0,0,0,0.46);\n        box-shadow: 0px 2px 11px 0px rgba(0,0,0,0.46);\n        \n\n        @include styles.mobile {\n            right: 1rem;\n            top: 4.5rem;\n        }\n\n        div {\n            width: 100%;\n        }\n\n        .profile__details {\n            display: flex;\n            align-items: center;\n            padding: 0.5rem;\n            line-height: 2.5rem;\n            gap: 0.5rem;\n            flex-direction: column;\n            border-bottom: 1px solid var(--border-color);\n\n            .profileIconWithImage img {\n                width: 60px;\n                height: 60px;\n            }\n\n            div {\n                text-align: center;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n            }\n            a {\n                width: 50px;\n                height: 50px;\n                font-size: 1.5rem;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n            } \n        }\n\n        .logout__container {\n            a {\n                padding: .5rem .5rem;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                gap:0.5rem;\n                &:hover {\n                    background-color: var(--hover-bg);\n                    border-radius: 0 0 10px 10px;\n                }\n            } \n        }\n\n        a {\n            text-decoration: none;\n            display: block;\n            cursor: pointer;\n        } \n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
